module.exports = __webpack_public_path__ + "media/images/icon-photo@3x-cbaac4eee6ac64ac390b49ae1fef58fd.png";